import { useNavigate } from "react-router-dom";
import { StandardBar } from "../../BarIndicator/StandardBar";
import * as S from "./TestItem.style";

import { ReactComponent as IconArrow } from "@/styles/assets/svg/icon_arrow_right.svg";

interface TestCardItemProps {
  data?: any;
  onClick?: (data: any) => void;
}

export const TestItem = ({ data, onClick }: TestCardItemProps) => {
  const navigate = useNavigate();

  const handleNavigate = (data: any) => {
    navigate("/test/detail", { state: { data: data } });
  };

  return (
    // <S.TestItem onClick={() => navigate("/test/detail")}>
    <S.TestItem
      onClick={() => {
        if (onClick) {
          onClick(data);
        } else {
          handleNavigate(data);
        }
      }}
    >
      <S.Test>
        <S.TestImg>
          <img
            src={`${process.env.REACT_APP_IMAGE_URL}/${data.src}.${data.ext}`}
            alt="테스트 추천 이미지"
          />
        </S.TestImg>
        <S.TestInfoBox>
          <S.TestTitle>
            <span>{data.name}</span> <IconArrow />
          </S.TestTitle>

          <S.TextStatus>
            {data.status > 0 && data.status < 100 && (
              <StandardBar shade={true} current={data.status} />
            )}

            {data.status === 0
              ? "소요시간 nn분"
              : parseInt(data.status) === 100
              ? "참여완료"
              : `참여진행중(${data.status}%)`}
          </S.TextStatus>
        </S.TestInfoBox>
      </S.Test>
    </S.TestItem>
  );
};
